import React, { useMemo } from 'react';
import { useDeviceOrientation, type OrientationAngle } from './useDeviceOrientation';

interface RotatingControlsResult {
  /** Raw device angle (0, 90, 180, 270) */
  angle: OrientationAngle;
  /** Apply to button / icon wrappers so they stay upright when device tilts */
  buttonStyle: React.CSSProperties;
}

export const useRotatingControls = (): RotatingControlsResult => {
  const { angle } = useDeviceOrientation();

  const buttonStyle = useMemo((): React.CSSProperties => {
    // Rotate icons opposite to device tilt so they stay upright.
    // Normalize to shortest-path rotation (avoid -270° spinning 3/4 turn).
    const rotation = angle <= 180 ? -angle : 360 - angle;

    return {
      transform: `rotate(${rotation}deg)`,
      transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      transformOrigin: 'center center',
    };
  }, [angle]);

  return { angle, buttonStyle };
};
